import { useMemo } from 'react'
import type { ServiceCountItem, RobotServiceCountItem } from '@/types/api'
import { CommonBarChart } from './CommonBarChart'

interface Props {
  data: ServiceCountItem[] | RobotServiceCountItem[]
}

export function ServiceCountChart({ data }: Props) {
  const formattedData = useMemo(() => {
    const list = Array.isArray(data) ? data : []
    return list
      .map((item: any) => {
        return {
          name: item.robotName,
          count: item.totalReceptions ?? item.count ?? 0,
        }
      })
      .sort((a, b) => b.count - a.count)
  }, [data])

  return (
    <CommonBarChart
      title="LƯU LƯỢNG TƯƠNG TÁC THEO ROBOT"
      data={formattedData}
      xKey="name"
      yKey="count"
      theme="blue"
      legendLabel="Số lần tương tác"
      activeType="badge"
    />
  )
}
